<template>

  <div class="app"
       v-if="$store.state.translationsLoaded">

    <header class="header">
      <div class="container">

        <user-menu></user-menu>

      </div>
    </header>

    <div class="content content-outer">
      <div class="container">

        <router-view/>

      </div>
    </div>

    <main-footer></main-footer>

    <help-pane></help-pane>

    <chat-pane/>

    <video-pane/>

    <user-logout-timer></user-logout-timer>

    <saving-indicator></saving-indicator>

  </div>

</template>

<script>
import SavingIndicator from '@/components/SavingIndicator'
import VideoPane from '@/components/VideoPane.vue'

export default {
    components: { VideoPane, SavingIndicator}
}
</script>

<script>

import Vue from 'vue'
import {store} from './store'
import User from './User'
import Theme from '@/providers/Theme'

export default Vue.extend({
    name: 'app',
    // manipulate page header (tile, favicons, etc.) using VueHead
    head: {
        title: Theme.getVueHeadPageTitle,
        link: Theme.getVueHeadLinkHeaders,
    },
    beforeCreate() {
        //Load user object etc. from local storage
        this.$store.dispatch('init')
    },
    created() {
        Theme.setCustomTheme()
        this.$user.loadEnvironment()
        this.$user.loadUserState()
        this.$user.checkAuth()
        this.$i18n.loadTranslations('en', store, User)
    }
})

</script>


<style lang="scss">

// base styles for app
@import '../../../sass/base';

// the default theme always applies, and supplies default values for all CSS variables -
// the variables can be overridden by other themes if they apply
@import '../../../public/themes/default/style.scss';

// import all custom themes here - only one will be active at a time, but we select it at runtime
@import '../../../public/themes/wellcoaches/style.scss';
@import '../../../public/themes/shs/style.scss';
@import '../../../public/themes/conifer/style.scss';

@media print {
  .app > header {
    display: none;
  }
}

.row.divider {
  border-top: solid 1px #ddd !important;
  margin: 15px 0 0 0;
  padding-top: 10px;
}

</style>
